import {
  configApiRef,
  githubAuthApiRef,
} from "@backstage/core-plugin-api";
import {
  ScmAuth,
  scmAuthApiRef,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from "@backstage/integration-react";
import { ApiBlueprint } from '@backstage/frontend-plugin-api';
import {
  apiDocsConfigRef,
  defaultDefinitionWidgets,
  ApiDefinitionWidget,
} from "@backstage/plugin-api-docs";
import { ApiEntity } from "@backstage/catalog-model";
import { ScalarApiDefinition } from "./components/catalog/ScalarApiDefinitionWidget";


export const scmIntegrationsApi = ApiBlueprint.make({
    name: 'scm-integrations',
    params: defineParams =>
        defineParams({
            api: scmIntegrationsApiRef,
            deps: { configApi: configApiRef },
            factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
        }),
});

export const scmAuthApi = ApiBlueprint.make({
    name: 'scm-auth',
    params: defineParams =>
        defineParams({
            api: scmAuthApiRef,
            deps: { githubAuthApi: githubAuthApiRef },
            factory: ({ githubAuthApi }) =>
                ScmAuth.merge(ScmAuth.forGithub(githubAuthApi)),
        }),
});

// Override the api-docs renderer so `openapi` specs render with Scalar
// (multi-language code snippets, cleaner layout) instead of the default
// Swagger UI. All other API types (asyncapi, graphql, ...) fall back to the
// built-in default widgets.
//
// Named 'config' and attached to a module targeting pluginId 'api-docs' (see
// App.tsx) so this OVERRIDES the api-docs plugin's built-in `api:api-docs/config`
// extension instead of registering a second provider of the same API (which
// throws API_FACTORY_CONFLICT).
export const apiDocsConfigApi = ApiBlueprint.make({
    name: 'config',
    params: defineParams =>
        defineParams({
            api: apiDocsConfigRef,
            deps: {},
            factory: () => {
                const definitionWidgets = defaultDefinitionWidgets();
                return {
                    getApiDefinitionWidget: (apiEntity: ApiEntity) => {
                        if (apiEntity.spec.type === "openapi") {
                            return {
                                type: "openapi",
                                title: "OpenAPI",
                                rawLanguage: "yaml",
                                component: definition => (
                                    <ScalarApiDefinition definition={definition} />
                                ),
                            } as ApiDefinitionWidget;
                        }
                        return definitionWidgets.find(
                            widget => widget.type === apiEntity.spec.type,
                        );
                    },
                };
            },
        }),
});